/**
 * Location added to logs
 */
export const PACKAGE_LOCATION = 'jira.platform.serviceworker.window';

/**
 * Where the service-worker.js file is fetched from.
 * This is ServiceWorkerResource in greenhopper.
 *
 * It'll serve the 'entry/service-worker' or 'entry/service-worker-kill-switch'
 * chunks based on FD-12480.
 */
export const SERVICE_WORKER_RESOURCE_ENDPOINT = '/rest/greenhopper/1.0/frontend/service-worker.js';

/**
 * Scope of pages the service worker controls.
 */
export const SERVICE_WORKER_SCOPE = '/jira/software/projects/';
